import { render, staticRenderFns } from "./Collaborator.vue?vue&type=template&id=ba34283e&scoped=true"
import script from "./Collaborator.vue?vue&type=script&lang=js"
export * from "./Collaborator.vue?vue&type=script&lang=js"
import style0 from "./Collaborator.vue?vue&type=style&index=0&id=ba34283e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba34283e",
  null
  
)

export default component.exports